import { useTranslation } from 'react-i18next';
import ButtonDropdown from '../button/ButtonDropdown';
import ConfirmationModalWithReason from '../modal/ConfirmationModelWithReason';
import { confirmAlert } from 'react-confirm-alert';
import { useState } from 'react';
import CheckCircle from '../svg/CheckCircle';
import AlertCircle from '../svg/AlertCirle';
import CrossCircle from '../svg/CrossCircle';
import Loader from '../loader/Loader';

enum ReceiptStateEnum {
  VALIDATED = 'validated',
  ONGOING = 'ongoing',
  REFUSED = 'refused',
}

interface SelectedAction {
  state: ReceiptStateEnum;
  labelKey: string;
  buttonClass: string;
}

interface FooterValidationProps {
  isAllValid: boolean;
  count: number;
  mainBtnText: string;
  updateAllReceiptsState: (state: string, reason: string | null) => void;
  isLoading: boolean
}

const FooterValidation = ({ isAllValid, count, mainBtnText, updateAllReceiptsState, isLoading }: FooterValidationProps): JSX.Element => {
  const { t } = useTranslation();
  const [newState, setNewState] = useState<ReceiptStateEnum>(ReceiptStateEnum.VALIDATED);

  const [selectedAction, setSelectedAction] = useState<SelectedAction>({
    state: ReceiptStateEnum.VALIDATED,
    labelKey: 'button.validate-all',
    buttonClass: 'button-success',
  });

  const handleMainActionClick = () => {
    if (selectedAction.state === ReceiptStateEnum.REFUSED) {
      confirmHandleRefused();
    } else {
      updateAllReceiptsState(count > 0 ? ReceiptStateEnum.ONGOING : ReceiptStateEnum.VALIDATED, null);
    }
  };

  const confirmHandleRefused = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return <ConfirmationModalWithReason
          message={t('modal.confirmation.message-state-folder-update-definitive')}
          onConfirm={(message) => handleRefused(message)}
          onClose={onClose}
        />
      },
    })
  }

  const handleRefused = (reason: string | null) => {
    updateAllReceiptsState(ReceiptStateEnum.REFUSED, reason);

    setSelectedAction({
      state: ReceiptStateEnum.REFUSED,
      labelKey: 'button.refuse-all',
      buttonClass: 'button-error',
    });
  }

  const handleDropdownSelection = (newState: ReceiptStateEnum, newLabelKey: string, newButtonClass: string) => {
    setNewState(newState)

    setSelectedAction({
      state: newState,
      labelKey: newLabelKey,
      buttonClass: newButtonClass,
    });
  };

  const actions = [
    {
      label: t('button.refuse-all'),
      classes: `dropdown-button__error u-txt-uppercase u-pys`,
      onClick: () => handleDropdownSelection(ReceiptStateEnum.REFUSED, 'button.refuse-all', 'button-error')
    },
    {
      label: t('button.validate-all'),
      classes: `dropdown-button__success u-txt-uppercase u-pys`,
      onClick: () => handleDropdownSelection(ReceiptStateEnum.VALIDATED, 'button.validate-all', 'button-success')
    },
  ]

  const baseButtonClasses = "button button--medium u-pxb";
  const statusTextClasses = isAllValid ? (newState === ReceiptStateEnum.VALIDATED ? 'text-green-600' : 'text-red-600') : 'text-red-600';

  return (
    <div id="footer-bg" className="custom-floating-footer">
      <div className="custom-floating-footer-inner u-pxm u-pyb u-mbs">
        <div id="status-text" className={`text-sm font-medium ${statusTextClasses}`}>
          {isAllValid ? (
            newState === ReceiptStateEnum.VALIDATED ? (
              <span className="flex items-center gap-2 font-600">
                <CheckCircle color='var(--success)' />
                {t('validation.subscription-valid')}
              </span>

            ) : (
              <span className="flex items-center gap-2 font-600">
                <CrossCircle color='var(--error)' />
                {t('validation.subscription-refuse')}
              </span>

            )
          ) : (
            <span className="flex items-center gap-2 font-600">
              <AlertCircle />
              {t('validation.subscription-refuse-count', { count: count })}
            </span>
          )}
        </div>

        <div className="flex gap-3 items-center">
          {isLoading ?
            <Loader />
            :
            isAllValid ? (
              <ButtonDropdown
                label={t(selectedAction.labelKey)}
                mainActionClick={handleMainActionClick}
                actions={actions}
                className={`${baseButtonClasses} ${selectedAction.buttonClass}`}
                menuPosition='top'
                arrowColor='white'
              />
            ) : (
              // 2. ÉTAT ERREUR (Bouton Simple)
              <div onClick={handleMainActionClick}>
                <a className={`${baseButtonClasses} button-error`}>
                  {mainBtnText}
                </a>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default FooterValidation;
